import { useTranslation } from '@packlink/translation-provider';
import { Divider, DividerVariant, Button, ButtonVariant } from '@shipengine/giger';
import { getServiceInformationStyles, getServiceInformationDividerStyles } from './ServiceInformationStyles.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { ServiceCardDialogType } from '../ServiceCardDialog/ServiceCardDialog.js';

const ServiceInformation = _ref => {
  let {
    detailsNode,
    dialogOpen,
    dropOffNode,
    onToggleDialog
  } = _ref;
  const {
    t
  } = useTranslation();
  if (dialogOpen === ServiceCardDialogType.DETAILS) {
    return jsx("article", {
      css: getServiceInformationStyles,
      children: detailsNode
    });
  }
  return jsxs("article", {
    css: getServiceInformationStyles,
    children: [dropOffNode, jsx(Divider, {
      variant: DividerVariant.GRAY,
      css: getServiceInformationDividerStyles
    }), jsx(Button, {
      onClick: onToggleDialog,
      variant: ButtonVariant.TEXT,
      children: t('service-card.dialog.close')
    })]
  });
};

export { ServiceInformation };
//# sourceMappingURL=ServiceInformation.js.map
